import React from "react";
import { GRID_ACTION_TYPES, GridActionType } from "../../../assets/types";
import { Constants } from "../../../assets/utils/lib/constants";
import { useSnackbar } from "../../../assets/vfx/snackbar/vfxSnackbarContext";
import { QuestionnaireResponseService } from "./questionnaireResponseService";
import { DeviceQuestionnaireResponseDto, FormDto } from "../../../services/dto";
import { QuestionnaireResponseView } from "./questionnaireResponseView";
import { QuestionnaireResponsePage } from "./questionnaireResponsePage";
import { SearchDto } from "../../../assets/utils/lib/searchDto";
import { LoadingIndicator } from "../../../assets/vfx";

interface QuestionnaireResponseContainerProps {
  questionnaireId?: string;
  searchValues?: SearchDto;
}

export const QuestionnaireResponseContainer = (
  props: QuestionnaireResponseContainerProps
) => {
  const [data, setData] = React.useState<DeviceQuestionnaireResponseDto>();
  const [drawerType, setDrawerType] = React.useState<GridActionType>(
    GRID_ACTION_TYPES.HIDDEN
  );

  const questionnaireResponseQuery =
    QuestionnaireResponseService.getQuestionnaireResponseQuery(
      data?.iD ?? Constants.emptyGuid
    );

  const handleCustomEvent = (actionType: string, dataId: string) => {
    setDrawerType("view");
    setData({ iD: dataId } as DeviceQuestionnaireResponseDto);
  };

  const closeDrawer = () => setDrawerType(GRID_ACTION_TYPES.HIDDEN);

  const renderDrawerContent = () => {
    const isDataLoaded =
      questionnaireResponseQuery?.data &&
      questionnaireResponseQuery?.data?.length > 0;

    return questionnaireResponseQuery.isLoading ? (
      <LoadingIndicator isFullPage={true} />
    ) : drawerType != GRID_ACTION_TYPES.HIDDEN && isDataLoaded ? (
      <QuestionnaireResponseView
        data={questionnaireResponseQuery?.data}
        show={true}
        onHide={() => closeDrawer()}
        key={1}
      />
    ) : null;
  };
  return (
    <>
      <QuestionnaireResponsePage
        questionnaireId={props.questionnaireId}
        onCustomEvent={handleCustomEvent}
      />
      {renderDrawerContent()}
    </>
  );
};
